import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
  standalone: false,
})
export class ChipsComponent implements OnInit {
  @Input() item: any;
  @Input() removeItem: boolean = false;
  @Input() selected: boolean = false;
  @Input() variant: 'default' | 'intern-list' = 'default';

  @Output() removeFromList = new EventEmitter();
  @Output() chipClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  fnRemoveItem(id: number) {
    this.removeFromList.emit(id);
  }

  fnChipClick(): void {
    this.chipClick.emit(this.item);
  }
}
